/* eslint-disable no-template-curly-in-string */
export const hardcodedErrorCodes = {
    ACTION_REJECTED: 'User rejected the action',
    FE_NOT_ENOUGH_WALLET_BALANCE: 'It looks like the amount you entered is higher than your connected wallet balance. Please double-check the amount and try again.',
    FE_NOT_ENOUGH_WITHDRAWABLE_BALANCE: 'It looks like the amount you entered is higher than allowed withdrawable balance. Please double-check the amount and try again.',
    FE_NOT_ENOUGH_BALANCE_TO_OPEN_POSITION: 'The entered amount exceeds your current balance. Change the amount and try again, or deposit more funds to your balance.',

    FE_OPEN_POSITION_AMOUNT_RANGE: 'The entered amount is outside the allowed range of {min} and {max}. Change the amount and try again.',
    FE_TP_RANGE: 'The entered take profit price is outside the allowed range of {min} and {max}. Change the take profit price and try again.',
    FE_SL_RANGE: 'The entered stop loss price is outside the allowed range of {min} and {max}. Change the stop loss price and try again.',
};

const normalizeErrorMessage = (message: string) => {
    return message?.split('Details:')?.[0] || message;
}

export const getErrorMessage = (err: any) => {
    if (err.response?.data) {
        err = err.response.data;
    }
    return (hardcodedErrorCodes as any)[err?.code] || err?.reason || normalizeErrorMessage(err?.message) || 'Something went wrong';
}